import React, { useState } from 'react';

import { Helmet } from 'react-helmet';

import { Button, Card, CardContent, Container, Stack } from '@mui/material';

import OfferBreadcrumbs from '~/components/Common/Elements/OfferBreadcrumbs';
import PageHeader from '~/components/Common/Elements/PageHeader';
import PropertyReviewForm from '~/components/Common/Forms/PropertyReviewForm';

import generateRandomString from '~/utils/generateRandomString';

export default function PropertyReviewsEdit({
  schema,
  vendor,
  vendorId,
  property,
  propertyId,
  reviewsData: initialReviewsData,
}) {
  const [reviewsData, setReviewsData] = useState(initialReviewsData);

  const addNewPropertyReview = () => {
    setReviewsData((prevState) => [
      ...prevState,
      {
        _id: generateRandomString(),
      },
    ]);
  };

  const removePropertyReview = (formKey) => {
    setReviewsData((prevState) => prevState.filter((review) => review.id !== formKey));
  };

  return (
    <Container>
      <Helmet>
        <title>
          Vendor | {vendor?.name || vendorId} | {property?.name || propertyId} | Edit Property Reviews
        </title>
      </Helmet>

      <OfferBreadcrumbs
        vendor={{ label: vendor?.vendor_name || vendor?.name || 'Vendor', href: `/vendors/${vendorId}` }}
        property={{ label: property?.name || 'Property', href: `/vendors/${vendorId}/properties/${propertyId}` }}
        currentPage="Reviews"
      />
      <PageHeader title="Edit property reviews" />

      <Stack direction="column" spacing={2}>
        {reviewsData.map((review, i) => (
          <Card variant="outlined" key={i}>
            <CardContent>
              <PropertyReviewForm
                property={property}
                propertyId={propertyId}
                formKey={review.id}
                reviewData={review}
                schema={schema}
                onRemovePropertyReview={removePropertyReview}
              />
            </CardContent>
          </Card>
        ))}

        <div>
          <Button variant="contained" onClick={addNewPropertyReview}>
            Add
          </Button>
        </div>
      </Stack>
    </Container>
  );
}
